import { render, staticRenderFns } from "./DetailLiquidation.vue?vue&type=template&id=8593cc68"
import script from "./DetailLiquidation.vue?vue&type=script&lang=js"
export * from "./DetailLiquidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports